module.exports = __webpack_public_path__ + "img/70.b7f69e6d.gif";